import { render, staticRenderFns } from "./CompanyManageSave.vue?vue&type=template&id=72f3a4ac&scoped=true"
import script from "./CompanyManageSave.vue?vue&type=script&lang=js"
export * from "./CompanyManageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3a4ac",
  null
  
)

export default component.exports